import { gql } from '@apollo/client';

export const postEsClienteCuentasFAL = gql`
mutation EsClienteCajasRQ{
    esClienteCuentasFAL(input:$input)  
    @rest(type: "EsClienteCuentasFALRS", path: "/api/gateway/formularios/AdhesionProvinciaCompras",  method: "PATCH"){
            sucursal
            ubicom
            razonSocial
        }
}
`